<div class="webcam-container">
  <div class="webcam-preview">
    <webcam
      [height]="400"
      [width]="500"
      [trigger]="triggerObservable"
      (imageCapture)="handleImage($event)"
      *ngIf="showWebcam"
      [allowCameraSwitch]="allowCameraSwitch"
      (initError)="handleInitError($event)"
      [videoOptions]="videoOptions"
    ></webcam>
  </div>
  <div class="capture-action-row">
    <button class="capture-photo-btn" (click)="triggerSnapshot()" [disabled]="!cameraReady">
      <i class="pi pi-camera"></i>
      <span>{{ cameraReady ? 'Capture Photo' : 'Preparing camera...' }}</span>
    </button>
  </div>
</div>
